import { useEffect } from "react";

declare global {
    interface Window {
        Tawk_API?: any;
        Tawk_LoadStart?: Date;
    }
}

const TawkChat = () => {
    useEffect(() => {
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_LoadStart = new Date();
        const s1 = document.createElement("script");
        s1.async = true;
        s1.src = "https://embed.tawk.to/66f40f714cbc4814f7de8635/1i8klol4t";
        s1.charset = "UTF-8";
        s1.setAttribute("crossorigin", "*");

        document.body.appendChild(s1);

        return () => {
            document.body.removeChild(s1);
        };
    }, []);

    return null;
};

export default TawkChat;
